import { useEffect } from 'react';

interface SeoHeadOptions {
  title: string;
  description: string;
  robots?: string;
}

function upsertMetaByName(name: string, content: string) {
  let meta = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function upsertMetaByProperty(property: string, content: string) {
  let meta = document.head.querySelector(
    `meta[property="${property}"]`
  ) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('property', property);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

export function useSeoHead({ title, description, robots = 'noindex, nofollow' }: SeoHeadOptions) {
  useEffect(() => {
    document.title = title;
    upsertMetaByName('description', description);
    upsertMetaByName('robots', robots);

    // Social previews
    upsertMetaByProperty('og:title', title);
    upsertMetaByProperty('og:description', description);
    upsertMetaByProperty('og:type', 'website');
    upsertMetaByName('twitter:card', 'summary');
    upsertMetaByName('twitter:title', title);
    upsertMetaByName('twitter:description', description);
  }, [description, robots, title]);
}
